import useStore from "./store";
import { CONNECTOR } from "./reducers";

export const displayRewards = (tenant_code: string, user_id: string) => {
  const dispData =
    useStore.getState().displayedRewards[tenant_code + CONNECTOR + user_id];
  return dispData ? dispData : [];
};
